module.exports = __webpack_public_path__ + "static/media/lobster-mobiles-tiny.31743c9e.jpg";